import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FaRupeeSign, FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import './CourseManagement.css';
import { coursesByInstructor, getInstructorEarningsByCourse, getAverageRatingByCourse } from '../../Services/Services';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UpdateCourse from './UpdateCourse';

const CourseManagement = () => {
  const [courses, setCourses] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [earnings, setEarnings] = useState('');
  const [averageRating, setAverageRating] = useState(null);
  const [sectionTitle, setSectionTitle] = useState('');
  const [lessons, setLessons] = useState([{ title: '', video: null }]);
  const [modalType, setModalType] = useState('');
  const userId = localStorage.getItem('userId');
  const { t } = useTranslation();

  const fetchCourses = async () => {
    try {
      const response = await coursesByInstructor(userId);
      setCourses(Array.isArray(response?.data) ? response?.data : []);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  };

  useEffect(() => {


    fetchCourses();
  }, [userId]);

  const navigate = useNavigate();

  const handleAddNewCourse = () => {
    navigate('/add-course');
  };

  const handleDollarClick = async (course) => {
    if (course.paymentType === 'ONE_TIME') return;
    try {
      const earningsResponse = await getInstructorEarningsByCourse(course?.courseId);
      if (!earningsResponse || !earningsResponse.data) {
        throw new Error('Invalid earnings data received.');
      }
      const earningsData = earningsResponse.data;
      setEarnings(earningsData);
      setSelectedCourse(course);
      setModalType('earnings');
      setModalIsOpen(true);
    } catch (error) {
      toast.dismiss();
      toast.error('Error fetching earnings: ' + (error.message || error));
    }
  };

  const handleStarClick = async (course) => {
    try {
      const response = await getAverageRatingByCourse(course?.courseId);
      setAverageRating(response.data);
      setSelectedCourse(course);
      setModalType('rating');
      setModalIsOpen(true);
    } catch (error) {
      toast.dismiss();
      console.error('Error fetching average rating:', error);
      toast.error('Error fetching average rating.');
    }
  };

  const handleEditClick = (course) => {
    setSelectedCourse(course);
    setSectionTitle('');
    setLessons([{ title: '', video: null }]);
    setModalType('section');
    setModalIsOpen(true);
  };

  // const handleSaveSection = async () => {
  //   setLoading(true);

  //   const formData = new FormData();

  //   const sectionRequestWrapper = {
  //     sectionRequests: [
  //       {
  //         title: sectionTitle,
  //         lessons: lessons.map((lesson) => ({
  //           title: lesson.title,
  //           video: lesson.video,
  //         })),
  //       },
  //     ],
  //   };

  //   sectionRequestWrapper.sectionRequests.forEach((section, sectionIndex) => {
  //     formData.append(`sectionRequests[${sectionIndex}].title`, section.title);

  //     section.lessons.forEach((lesson, lessonIndex) => {
  //       formData.append(`sectionRequests[${sectionIndex}].lessons[${lessonIndex}].title`, lesson.title);

  //       if (lesson.video) {
  //         formData.append(`sectionRequests[${sectionIndex}].lessons[${lessonIndex}].video`, lesson.video);
  //       }
  //     });
  //   });

  //   try {
  //     const response = await addSectionToCourse(selectedCourse.courseId, formData, userId);
  //     if (response.data.success) {
  //       toast.success('Section added successfully!');
  //       setModalIsOpen(false);
  //     } else {
  //       toast.error('Failed to add section');
  //     }
  //   } catch (error) {
  //     setLoading(false);

  //     if (error.response.status === 500) {
  //       const errorMessage = extractLastLine(error.response.data?.data || "Internal server error.");
  //       toast.error(`${errorMessage}`);
  //     } else if (error.response.status === 400) {
  //       const errorMessage = extractLastLine(error.response.data?.data || "Invalid request data.");
  //       toast.error(`${errorMessage}`);
  //     } else {
  //       toast.error("An unexpected error occurred while processing the request.");
  //     }
  //   }
  //   finally {
  //     setLoading(false);
  //   }
  // };

  // const extractLastLine = (errorData) => {
  //   if (typeof errorData !== 'string') {
  //     return "Invalid error data format.";
  //   }

  //   const lines = errorData.split('\n');
  //   let lastLine;

  //   if (lines.some(line => line.toLowerCase().includes('video'))) {
  //     lastLine = lines[lines.length - 2];
  //   } else if (lines.some(line => line.toLowerCase().includes('image'))) {
  //     lastLine = lines[lines.length - 3];
  //   } else {
  //     lastLine = lines[lines.length - 1];
  //   }

  //   return lastLine || "An unexpected error occurred.";
  // };


  // const handleLessonChange = (index, field, value) => {
  //   const updatedLessons = [...lessons];
  //   updatedLessons[index][field] = value;
  //   setLessons(updatedLessons);
  // };

  // const handleLessonFileChange = (index, event) => {
  //   const file = event.target.files[0];
  //   if (file && file.type === 'video/mp4') {
  //     const updatedLessons = [...lessons];
  //     updatedLessons[index].video = file;
  //     setLessons(updatedLessons);
  //   } else {
  //     toast.error('Please upload only MP4 files.');
  //   }
  // };

  // const addLesson = () => {
  //   setLessons([...lessons, { title: '', video: null }]);
  // };

  // const removeLesson = (index) => {
  //   const updatedLessons = lessons.filter((_, i) => i !== index);
  //   setLessons(updatedLessons);
  // };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedCourse(null);
    setAverageRating(null);
    setEarnings('');
    setSectionTitle('');
    setLessons([{ title: '', video: null }]);
    setModalType('');
  };

  const truncateDescription = (description, wordCount) => {
    const words = description.split(' ');
    return words.length > wordCount ? words.slice(0, wordCount).join(' ') + '...' : description;
  };

  const getModalStyles = () => {
    switch (modalType) {
      case 'earnings':
        return {
          content: {
            backgroundColor: '#fff',
            padding: '20px',
            borderRadius: '8px',
            width: '70%',
            height: '30%',
            maxWidth: '500px',
            margin: 'auto',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            overflowY: 'auto',
          },
        };
      case 'rating':
        return {
          content: {
            backgroundColor: '#fff',
            padding: '25px',
            borderRadius: '8px',
            width: '60%',
            height: '25%',
            maxWidth: '600px',
            margin: 'auto',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            overflowY: 'auto',
          },
        };
      case 'section':
        return {
          content: {
            backgroundColor: '#fff',
            padding: '30px',
            borderRadius: '8px',
            width: '80%',
            maxWidth: '700px',
            margin: 'auto',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            overflowY: 'auto',
          },
        };
      default:
        return {
          content: {
            backgroundColor: '#fff',
            padding: '30px',
            borderRadius: '8px',
            width: '80%',
            maxWidth: '600px',
            margin: 'auto',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            overflowY: 'auto',
          },
        };
    }
  };

  return (
    <div className="course-management-container">
      <button className="new-course-button" onClick={handleAddNewCourse}>
        {t('NewCourse')}
      </button>

      <table className="course-table">
        <thead>
          <tr>
            <th>{t('CourseName')}</th>
            <th>{t('Description')}</th>
            <th>{t('Price')}</th>
            <th>{t('Action')}</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {courses.map((course) => (
            <tr key={course.courseId}>
              <td>{course.title}</td>
              <td>{truncateDescription(course.description, 6)}</td>
              <td>{course.price}</td>
              <td className="action-buttons">
                {course.paymentType !== 'ONE_TIME' && (
                  <button onClick={() => handleDollarClick(course)} title={t('ViewEarnings')}>
                    <FaRupeeSign className="Earnings-Button" />
                  </button>
                )}
                <button onClick={() => handleStarClick(course)} title={t('ViewAverageRating')}>
                  <FontAwesomeIcon icon={faStar} className="Rating-Button" />
                </button>
                {course.completeStatus !== "COMPLETED" && (
                  <button onClick={() => handleEditClick(course)} title={t('EditCourse')}>
                    <FaEdit className="Edit-Button" />
                  </button>
                )}


              </td>
              <td>{course.approvalStatus.charAt(0).toUpperCase() + course.approvalStatus.slice(1).toLowerCase()}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Course Section Modal"
        style={getModalStyles()}
      >
        {/* {loading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <div style={{ textAlign: 'center', color: '#fff' }}>
              <div className="spinner" style={{
                border: '4px solid #f3f3f3',
                borderTop: '4px solid #3498db',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                animation: 'spin 2s linear infinite',
                marginBottom: '20px',
                marginLeft: '140px'
              }}></div>
              <div>Your Section is being added . Please wait ...</div>
            </div>
          </div>
        )} */}
        {modalType === 'earnings' && (
          <div>
            <h2>{selectedCourse?.title}</h2>
            <p>{t('Earnings')}: {earnings?.earnings}</p>
            <p>{t('EnrollmentCount')}: {earnings?.enrollmentCount}</p>
            <button onClick={closeModal} className="close-modal-button">{t('Close')}</button>
          </div>
        )}

        {modalType === 'rating' && (
          <div>
            <h2>{selectedCourse?.title}</h2>
            <p>{t('AverageRating')}: {averageRating}</p>
            <button onClick={closeModal} className="close-modal-button">{t('Close')}</button>
          </div>
        )}

        {modalType === 'section' && selectedCourse && (
          <div className='update-container'>
            <div className='update-flex-container'>
              <h2>Update Course</h2>  <button
                onClick={closeModal}
                style={{
                  padding: '10px 15px',
                  backgroundColor: '#f44336',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                }}
              >
                Cancel
              </button>
            </div>
            <UpdateCourse selectedCourse={selectedCourse} closeModal={closeModal} fetchCourses={fetchCourses} />
          </div>
        )}
      </Modal>
    </div>
  );
};

export default CourseManagement;